<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.sasEquivalenceDiplome"
      add-new-text="Ajouter un diplôme"
      :live="{ endpoint: 'sas-diplomes', sasId: sas.id }"
      :icon="$getIcon('school')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">
          {{ item.titreDuDiplome }}
        </p>
        <p class="mb-0">
          {{ item.universite }}
        </p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="diplome_titre" v-model="item.titreDuDiplome" :live="liveSasDiplomes(6302, item)" />
        <CatalogueLive code="diplome_pays" v-model="item.pays" :live="liveSasDiplomes(6305, item)" />
        <DatePickerLive
          code="diplome_date"
          v-model="item.dateDObtention"
          :live="liveSasDiplomes(6312, item)"
          :maxValue="convertDateToString(new Date())"
        />
        <CatalogueLive code="diplome_universite" v-model="item.etablissementAuCanadaARMCanada" :live="liveSasDiplomes(6315, item)" />
        <TextFieldLive
          code="diplome_universite-hors-canada"
          v-model="item.universite"
          :live="liveSasDiplomes(6304, item)"
          :opq-if="estAutre(item.etablissementAuCanadaARMCanada)"
        />
        <FileInput code="diplome_preuve" :file="item.copieDuDiplome" :live="liveSasDiplomes(6307, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"

export default {
  mixins: [CataloguesHelpers, StepFormWithValidation, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasDiplomes(cle, item) {
      return { endpoint: "sas-diplomes", cle: cle, fileId: item.id }
    },
    estAutre(universite) {
      return this.getCatalogueCodeById("7017", universite) == "autre"
    }
  }
}
</script>

<style></style>
